export const DASHBOARDS_CONST = {
  WIDGET_TYPE_TASKS: 'task',
  WIDGET_TYPE_SUBMISSIONS: 'submission',
};
